import { UserProto } from "build-ts/interface";
import showToast from "hooks/useCustomToast";


export const updateUser = async (user: UserProto): Promise<UserProto | null> => {
	try {
		const response = await fetch(process.env.REACT_APP_UPDATE_USER!, {
			method: "PUT",
			headers: {
				"Content-Type": "application/json",
			},
			credentials: "include",
			body: JSON.stringify(UserProto.toJSON(user)),
		});

		if (!response.ok) {
			showToast("Error updating user", "", "error");
			return null;
		}

		const data = await response.json();
		showToast("User updated successfully", "", "success");
		return UserProto.fromJSON(data);
	} catch (error) {
		showToast("Error updating user", "", "error");
		return null;
	}
};